<template>
  <div class="zoom" @click="bigSmall">
    <Icon type="md-expand" v-if="!isBigBool" />
    <Icon type="md-contract" v-if="isBigBool" />
  </div>
</template>

<style lang="scss" scope="scoped">
.zoom {
  font-size: 1.75em;
  cursor: pointer;
}
</style>

<script>
export default {
  data() {
    return {
      isBigBool: false, // 开关 false点击全屏
      changeWay: false // 全屏方式 false非h5全屏
    };
  },
  mounted() {
    window.addEventListener("resize", this.resizeCon);
    document.addEventListener("keydown", e => {
      // f11在非全屏下会触发 全屏状态下不触发
      if (e.keyCode == 122) {
        e.preventDefault();
        this.bigSmall();
      }
    });
  },
  methods: {
    bigSmall() {
      let vue = this;
      vue.isBigBool = !vue.isBigBool; // 全屏开关
      vue.changeWay = true;
      if (vue.isBigBool) {
        // 放大
        // 点击放大
        let element = document.documentElement;
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        }
      } else {
        // 点击缩小
        let element = document.documentElement;
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        }
      }
    },
    resizeCon() {
      let vue = this;
      if (vue.isBigBool && !vue.changeWay) {
        vue.isBigBool = false;
      }
      vue.changeWay = false;
    }
  }
};
</script>